import React from 'react';
import IframePage from "../iframe-page/iframe-page";
import config from "../../config";

const AnalyticsSessionsPage: React.FC = () => {
    return (
        <IframePage url={`${config.apiUrl}/dashboard/analytics/sessions`} />
    );
}

export default AnalyticsSessionsPage;